import { ca } from '@cian/analytics';

export function trackBuilderLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'go_to_developer_site',
    label: 'Link',
  });
}
